import {axiosInstance} from "@/plugins/axios";
import {Purchase, PurchaseFilter} from "@/modules/purchase/types";

export async function getPurchase(id: string) {
  const response = await axiosInstance.get(`purchases/${id}`);
  return response.data;
}

export async function getPurchaseByMaterialAndSupplierId(payload: PurchaseFilter) {
  let url = `purchases?`;

  if (payload.id_material) {
    url += `&id_material=${payload.id_material}&start_date=${payload.start_date}&end_date=${payload.end_date}`;
  }

  if (payload.id_supplier) {
    url += `&id_supplier=${payload.id_supplier}`;
  }

  const response = await axiosInstance.get(url);
  return response.data;
}

export async function getPurchases(payload: PurchaseFilter) {
  let url = `purchases?start_date=${payload.start_date}&end_date=${payload.end_date}`;

  if (payload.limit) {
    url += `&limit=${payload.limit}&offset=${payload.offset}`
  }

  if (payload.field === "SUPPLIER" && payload.search && payload.search !== "") {
    url += `&supplier=${payload.search}`
  }

  if (payload.field === "MATERIAL" && payload.search && payload.search !== "") {
    url += `&material=${payload.search}`
  }

  const response = await axiosInstance.get(url);
  return response.data;
}

export async function savePurchases(purchases: Purchase[]) {
  await axiosInstance.post(`purchases/create_or_update_many`, {
    purchases: purchases
  });
}
